
let React                     = require("react");

let SubscribeModalHub         = require("./SubscribeModalHub.jsx");
let CreateModalHub            = require("./CreateModalHub.jsx");
let UpdateModalHub            = require("./UpdateModalHub.jsx");
let ManageMembersModalHub     = require("./ManageMembersModalHub.jsx");


class HubModalManager extends React.Component {

    constructor() {
        super()
        this.state = {
            update: {show: false}, 
            //view: {show: false},
            create: {show: false},
            manage: {show: false},
            //transfer: {show: true}, 
            subscribe: {show: false},

            hubCounts: {allowedNumberOfHubs:-1, currentNumberOfHubs:-1}
        };
        
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.setHubCounts = this.setHubCounts.bind(this);
    }

    componentDidMount(){
        this.props.childrenMethods("hubModalManager", {onOpen: this.onOpen, onClose: this.onClose})
    }

    onOpen(modal, config){
        this.setState({[modal]: {show: true, config}})
    }

    onClose(modal){
        this.setState({[modal]: {show: false}});
    }
    
    setHubCounts(allowedNumberOfHubs, currentNumberOfHubs){
        this.setState({hubCounts: {allowedNumberOfHubs, currentNumberOfHubs}});
    }

    render() {
        const { renderPage, history, hubs, currentHub} = this.props;
        
        const { subscribe, update, create, manage, hubCounts} = this.state;

        return  <React.Fragment>
                    <SubscribeModalHub {...this.props} show={subscribe.show} onClose={this.onClose}/>
                    <UpdateModalHub {...this.props} show={update.show} {...currentHub} onClose={this.onClose} onOpen={this.onOpen} history={history}/>
                    <CreateModalHub {...this.props} show={create.show} onClose={this.onClose} onOpen={this.onOpen} hubs={hubs} hubCounts={hubCounts}/>
                    <ManageMembersModalHub {...this.props} show={manage.show} {...currentHub} onClose={this.onClose} onOpen={this.onOpen} {...manage.config}/>

                    {renderPage({
                        onOpen:this.onOpen,
                        onClose:this.onClose,
                        setHubCounts: this.setHubCounts,
                    })}
                </React.Fragment>
    }
}

module.exports = HubModalManager;